export const enum HeaderTypeEnum {
  VERIFY_ACCOUNT = 'verify-account',
  COMPANY_REGISTRATION = 'company-registration',
  BASE = 'base',
}
